// import React, { useState, useEffect, useRef } from "react";
// import Joyride, { STATUS } from "react-joyride";
// import axios from "axios";
// import { AUTH_ENDPOINTS } from "../../config";
// import { useSearchParams, useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";

// // Add cache duration constant
// const ACCOUNTS_CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds
// const AUTH_STATUS_CHANGED = "auth_status_changed";

// const Accounts = ({ configModalClosed }) => {
//   const [accounts, setAccounts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showConnectOptions, setShowConnectOptions] = useState(false);
//   const [connectingProvider, setConnectingProvider] = useState(null);
//   const [searchParams] = useSearchParams();
//   const [error, setError] = useState(null);
//   const [successMessage, setSuccessMessage] = useState(null);
//   const dropdownRef = useRef(null);
//   const initialLoadRef = useRef(true);
//   const navigate = useNavigate();
//   const [runTour, setRunTour] = useState(false);
//   const [tourSteps, setTourSteps] = useState([]);
//   const addButtonRef = useRef(null);

//   // Add axios interceptor for global error handling
//   useEffect(() => {
//     // Add response interceptor to handle authentication errors
//     const interceptor = axios.interceptors.response.use(
//       (response) => response,
//       (error) => {
//         // When we get a sign-in redirect error but we're already authenticated
//         if (error.response && error.response.status === 401) {
//           console.error("Authentication error:", error);
//           // Check if we have a token
//           const token = Cookies.get("access_token");
//           if (token) {
//             // Refresh the accounts list instead of redirecting
//             fetchAccounts();
//             return Promise.resolve({ data: { status: "recovered" } });
//           }
//         }
//         return Promise.reject(error);
//       }
//     );

//     return () => {
//       // Clean up interceptor when component unmounts
//       axios.interceptors.response.eject(interceptor);
//     };
//   }, []);

//   useEffect(() => {
//     if (!loading) {
//       if (accounts.length === 0) {
//         console.log("Setting tour steps for accounts:", accounts);
//         setTourSteps([
//           {
//             target: ".add-account-button",
//             content: (
//               <div className="text-center">
//                 <h3 className="font-bold text-blue-600 mb-2">
//                   Let's get started!
//                 </h3>
//                 <p>Click this button to connect your first email account.</p>
//                 <p className="text-sm text-gray-600 mt-2">
//                   You'll need to connect at least one account to use all the
//                   features of our app.
//                 </p>
//               </div>
//             ),
//             disableBeacon: true,
//             placement: "right",
//             offset: 20,
//             spotlightClicks: true,
//           },
//         ]);

//         if (configModalClosed) {
//           console.log("Config modal closed, starting tour");
//           setTimeout(() => {
//             setRunTour(true);
//             console.log("Tour started");
//           }, 500);
//         } else {
//           const hasSeenTour = localStorage.getItem("has_seen_accounts_tour");
//           console.log("Has seen tour:", hasSeenTour);
//           if (!hasSeenTour) {
//             setTimeout(() => {
//               setRunTour(true);
//               console.log("Tour started (new user)");
//             }, 500);
//           }
//         }
//       }
//     }
//   }, [configModalClosed, loading, accounts]);

//   // Listen for auth status changes (like logout)
//   useEffect(() => {
//     const handleAuthChange = () => {
//       console.log("Auth status changed, updating accounts");
//       // Check if we're logged in
//       const token = Cookies.get("access_token");
//       if (!token) {
//         // If logged out, clear accounts cache
//         localStorage.removeItem("cached_accounts");
//         localStorage.removeItem("accounts_cache_timestamp");
//       } else {
//         // If logged in, refresh accounts
//         fetchAccounts();
//       }
//     };

//     window.addEventListener(AUTH_STATUS_CHANGED, handleAuthChange);
//     return () => {
//       window.removeEventListener(AUTH_STATUS_CHANGED, handleAuthChange);
//     };
//   }, []);

//   useEffect(() => {
//     // Initial fetch of accounts with cache handling
//     if (initialLoadRef.current) {
//       initialLoadRef.current = false;

//       // Check if we have recently cached accounts
//       const cachedAccounts = localStorage.getItem("cached_accounts");
//       const cacheTimestamp = localStorage.getItem("accounts_cache_timestamp");

//       if (cachedAccounts && cacheTimestamp) {
//         try {
//           const now = Date.now();
//           const lastCacheTime = parseInt(cacheTimestamp);
//           const cacheAge = now - lastCacheTime;

//           // If cache is still fresh, use it
//           if (cacheAge < ACCOUNTS_CACHE_DURATION) {
//             const parsedAccounts = JSON.parse(cachedAccounts);
//             console.log("Using cached accounts data");
//             setAccounts(parsedAccounts);
//             setLoading(false);

//             // Still fetch in background to update if needed
//             setTimeout(() => fetchAccounts(false), 100);
//             return;
//           }
//         } catch (error) {
//           console.error("Error parsing cached accounts:", error);
//         }
//       }

//       // If no cache or cache expired, fetch fresh data
//       fetchAccounts(true);
//     }

//     // Check if account was just connected or if there was an error
//     const accountConnected = searchParams.get("account_connected");
//     const connectionError = searchParams.get("error");

//     if (accountConnected === "true") {
//       setSuccessMessage("Email account successfully connected!");
//       setTimeout(() => setSuccessMessage(null), 3000);

//       // Force refresh accounts list when redirected back after connection
//       fetchAccounts(true);

//       // Remove the query parameter from URL by replacing state without these params
//       const params = new URLSearchParams(searchParams);
//       params.delete("account_connected");
//       navigate({ search: params.toString() }, { replace: true });
//     }

//     if (connectionError) {
//       setError(`Connection issue: ${decodeURIComponent(connectionError)}`);
//       setTimeout(() => setError(null), 5000);

//       // Remove the query parameter from URL
//       const params = new URLSearchParams(searchParams);
//       params.delete("error");
//       navigate({ search: params.toString() }, { replace: true });
//     }

//     // Add click outside listener for dropdown
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowConnectOptions(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [searchParams, navigate]);

//   const fetchAccounts = async (forceFresh = false) => {
//     try {
//       // If not forcing fresh data, check if we already have cached data
//       if (!forceFresh) {
//         const cachedAccounts = localStorage.getItem("cached_accounts");
//         const cacheTimestamp = localStorage.getItem("accounts_cache_timestamp");

//         if (cachedAccounts && cacheTimestamp) {
//           try {
//             const now = Date.now();
//             const lastCacheTime = parseInt(cacheTimestamp);
//             const cacheAge = now - lastCacheTime;

//             // If cache is still fresh, use it
//             if (cacheAge < ACCOUNTS_CACHE_DURATION) {
//               const parsedAccounts = JSON.parse(cachedAccounts);
//               console.log("Using cached accounts data silently");
//               setAccounts(parsedAccounts);
//               setLoading(false);
//               return;
//             }
//           } catch (error) {
//             console.error("Error parsing cached accounts:", error);
//           }
//         }
//       }

//       setLoading(true);
//       const response = await axios.get(AUTH_ENDPOINTS.USER_ACCOUNTS);
//       console.log("Accounts data:", response.data);

//       // Check if response is HTML instead of JSON (invalid API URL issue)
//       if (
//         typeof response.data === "string" &&
//         response.data.includes("<!doctype html>")
//       ) {
//         console.error(
//           "Received HTML instead of JSON. API URL configuration issue."
//         );
//         setError("API configuration error. Please check console logs.");
//         setAccounts([]);
//         setLoading(false);
//         return;
//       }

//       // Validate that data is an array
//       if (!Array.isArray(response.data)) {
//         console.error("Expected array but got:", typeof response.data);
//         setError("Unexpected data format received.");
//         setAccounts([]);
//         setLoading(false);
//         return;
//       }

//       // Add more detailed logging for avatar URLs and connection status
//       if (response.data && response.data.length > 0) {
//         response.data.forEach((account) => {
//           console.log(
//             `Account ${account.email} avatar: ${account.user_avatar || "none"}`
//           );
//           console.log(
//             `Account ${account.email} authenticated: ${account.is_authenticated}`
//           );
//         });
//       }

//       setAccounts(response.data);
//       setLoading(false);

//       // Cache the accounts data
//       localStorage.setItem("cached_accounts", JSON.stringify(response.data));
//       localStorage.setItem("accounts_cache_timestamp", Date.now().toString());
//     } catch (err) {
//       console.error("Error fetching accounts:", err);
//       setLoading(false);
//       setError("Failed to load accounts. Please try again.");
//       setTimeout(() => setError(null), 3000);

//       // Try to use cached data as fallback on error
//       try {
//         const cachedAccounts = localStorage.getItem("cached_accounts");
//         if (cachedAccounts) {
//           const parsedAccounts = JSON.parse(cachedAccounts);
//           setAccounts(parsedAccounts);
//         }
//       } catch (e) {
//         console.error("Error using cached accounts as fallback:", e);
//       }
//     }
//   };

//   const handleConnectAccount = async (provider) => {
//     try {
//       setConnectingProvider(provider);
//       let response;

//       if (provider === "google") {
//         response = await axios.post(AUTH_ENDPOINTS.GOOGLE_CONNECT);
//       } else if (provider === "outlook") {
//         response = await axios.post(AUTH_ENDPOINTS.OUTLOOK_CONNECT);
//       }

//       if (response && response.data && response.data.auth_url) {
//         // Store current route to return to after auth
//         sessionStorage.setItem("connecting_provider", provider);
//         sessionStorage.setItem("return_to_path", window.location.pathname);

//         // Redirect to auth URL
//         window.location.href = response.data.auth_url;
//       }
//     } catch (err) {
//       console.error(`Error connecting ${provider} account:`, err);
//       let errorMessage = `Failed to connect ${provider} account.`;

//       // Provide more specific error message if available
//       if (err.response && err.response.data && err.response.data.detail) {
//         errorMessage += ` ${err.response.data.detail}`;
//       }

//       setError(errorMessage);
//       setConnectingProvider(null);
//       setTimeout(() => setError(null), 3000);
//     }
//   };

//   const handleRemoveAccount = async (account) => {
//     if (!window.confirm("Are you sure you want to remove this account?")) {
//       return;
//     }

//     try {
//       await axios.post(AUTH_ENDPOINTS.REMOVE_ACCOUNT, {
//         email: account.email,
//       });
//       setSuccessMessage("Account removed successfully");
//       setTimeout(() => setSuccessMessage(null), 3000);

//       // Force refresh the accounts list
//       fetchAccounts(true);

//       // Also clear accounts cache to ensure we get fresh data
//       localStorage.removeItem("cached_accounts");
//       localStorage.removeItem("accounts_cache_timestamp");
//     } catch (err) {
//       console.error("Error removing account:", err);
//       let errorMessage = "Failed to remove account.";

//       if (err.response && err.response.status === 400) {
//         errorMessage =
//           err.response.data.detail ||
//           "Cannot remove the only account. At least one account is required.";
//       }

//       setError(errorMessage);
//       setTimeout(() => setError(null), 3000);
//     }
//   };

//   const handleJoyrideCallback = (data) => {
//     const { status } = data;

//     if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
//       setRunTour(false);
//       localStorage.setItem("has_seen_accounts_tour", "true");
//     }
//   };

//   useEffect(() => {
//     fetchAccounts(true);
//   }, []);

//   return (
//     <>
//       <Joyride
//         steps={tourSteps}
//         run={runTour}
//         continuous={true}
//         showSkipButton={true}
//         callback={handleJoyrideCallback}
//         debug={true}
//         disableScrolling={false}
//         locale={{
//           last: "Got it",
//           skip: "Skip",
//           next: "Next",
//           back: "Back",
//         }}
//         styles={{
//           options: {
//             primaryColor: "#1F9BFF",
//             zIndex: 9999,
//           },
//           tooltip: {
//             fontSize: "14px",
//             padding: "15px",
//             borderRadius: "10px",
//             backgroundColor: "white",
//             boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
//           },
//           tooltipContainer: {
//             textAlign: "center",
//           },
//           tooltipTitle: {
//             fontSize: "18px",
//             fontWeight: "600",
//             margin: "0 0 10px 0",
//             color: "#1F9BFF",
//           },
//           tooltipContent: {
//             padding: "5px 0",
//             fontSize: "14px",
//             color: "#4A5568",
//           },
//           buttonNext: {
//             backgroundColor: "#1F9BFF",
//             padding: "8px 15px",
//             fontSize: "14px",
//             fontWeight: "500",
//             borderRadius: "6px",
//             border: "none",
//             boxShadow: "0 4px 6px rgba(31, 155, 255, 0.2)",
//             transition: "all 0.2s ease",
//           },
//           buttonBack: {
//             color: "#1F9BFF",
//             marginRight: "10px",
//           },
//           buttonSkip: {
//             color: "#718096",
//             fontSize: "13px",
//           },
//           overlay: {
//             backgroundColor: "rgba(0, 0, 0, 0.5)",
//           },
//           spotlight: {
//             borderRadius: "8px",
//             boxShadow: "0 0 0 4px rgba(31, 155, 255, 0.3)",
//           },
//           floater: {
//             arrow: {
//               color: "white",
//               length: 12,
//               spread: 8,
//             },
//           },
//         }}
//       />
//       <div className="bg-[#1F9BFF1A] font-bold text-md w-[96%] m-auto p-3 rounded-md rounded-b-none flex items-center justify-between text-black mt-2 px-4">
//         <h1>Accounts</h1>
//         {error && (
//           <div className="text-red-600 text-sm font-normal mr-2">{error}</div>
//         )}
//         {successMessage && (
//           <div className="text-green-600 text-sm font-normal mr-2">
//             {successMessage}
//           </div>
//         )}
//       </div>
//       <div className="bg-white w-[96%] min-h-[35%] m-auto rounded-lg rounded-t-none flex pt-3 pb-2 mb-3 relative">
//         {loading ? (
//           <div className="flex justify-center items-center h-14 w-full">
//             <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-400"></div>
//           </div>
//         ) : (
//           <div className="p-2 flex flex-wrap gap-4 w-full">
//             {accounts.map((account, index) => {
//               // Define an array of background colors for different accounts
//               const bgColors = [
//                 "bg-blue-50 hover:bg-blue-100",
//                 "bg-purple-50 hover:bg-purple-100",
//                 "bg-green-50 hover:bg-green-100",
//                 "bg-amber-50 hover:bg-amber-100",
//                 "bg-rose-50 hover:bg-rose-100",
//                 "bg-cyan-50 hover:bg-cyan-100",
//               ];

//               // Get background color based on index (cycles through the array)
//               const bgColorClass = bgColors[index % bgColors.length];

//               // Get border color matching the background
//               const borderColorClass = bgColorClass
//                 .replace("bg-", "border-")
//                 .replace(" hover:bg-blue-100", "")
//                 .replace(" hover:bg-purple-100", "")
//                 .replace(" hover:bg-green-100", "")
//                 .replace(" hover:bg-amber-100", "")
//                 .replace(" hover:bg-rose-100", "")
//                 .replace(" hover:bg-cyan-100", "");

//               return (
//                 <div
//                   key={account.id}
//                   className={`w-50 ${borderColorClass} p-2 rounded-lg text-left flex flex-col ${bgColorClass} relative group transition-colors duration-200`}
//                 >
//                   <div className="flex items-center gap-1">
//                     <img
//                       src={account?.email_avatar || "/default-avatar.svg"}
//                       alt={`${account.email} avatar`}
//                       referrerPolicy="no-referrer"
//                       crossOrigin="anonymous"
//                       className="w-6 h-6 rounded-full"
//                       onError={(e) => {
//                         console.error(
//                           "Failed to load account avatar, using fallback",
//                           account?.user_avatar
//                         );
//                         e.target.onerror = null;
//                         e.target.src = "/default-avatar.svg";
//                       }}
//                     />
//                     <div className="ml-1 overflow-hidden">
//                       <p className="font-medium leading-none text-sm mb-1 truncate">
//                         {account?.full_name}
//                       </p>
//                       <p className="text-gray-500 leading-none text-xs truncate">
//                         {account?.email}
//                       </p>
//                     </div>
//                   </div>

//                   {/* Remove account button - shows on hover */}
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleRemoveAccount(account);
//                     }}
//                     className="absolute top-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity p-1 hover:bg-red-100 rounded-full"
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="h-4 w-4 text-red-500"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M6 18L18 6M6 6l12 12"
//                       />
//                     </svg>
//                   </button>
//                 </div>
//               );
//             })}

//             {/* Add account button with dropdown */}
//             <div className="relative" ref={dropdownRef}>
//               <button
//                 ref={addButtonRef}
//                 onClick={() => setShowConnectOptions(!showConnectOptions)}
//                 className="flex items-center justify-center w-10 h-10 add-account-button"
//               >
//                 <div className="bg-[#1F9BFF1A] rounded-full p-2 hover:bg-[#1F9BFF33] transition-colors">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-4 w-4 text-[#1F9BFF]"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 4v16m8-8H4"
//                     />
//                   </svg>
//                 </div>
//               </button>

//               {/* Connection options dropdown */}
//               {showConnectOptions && (
//                 <div className="absolute top-0 -right-48 w-44 bg-white rounded-lg shadow-lg z-50 border border-blue-100 overflow-hidden transition-all duration-200 ease-in-out transform">
//                   <div className="py-1 px-2 bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-blue-100">
//                     <h3 className="text-xs font-semibold text-blue-700">
//                       Connect account
//                     </h3>
//                   </div>
//                   <div className="py-0.5">
//                     <button
//                       onClick={() => {
//                         handleConnectAccount("google");
//                         setShowConnectOptions(false);
//                       }}
//                       disabled={connectingProvider === "google"}
//                       className="flex items-center w-full px-2 py-1 text-xs text-gray-700 hover:bg-blue-50 transition-colors"
//                     >
//                       <div className="flex-shrink-0 mr-2 bg-white p-0.5 rounded-full shadow-sm">
//                         <img
//                           src="https://www.google.com/favicon.ico"
//                           alt="Google"
//                           className="w-5 h-5"
//                         />
//                       </div>
//                       <div className="text-left">
//                         <p className="font-medium text-xs leading-tight">
//                           {connectingProvider === "google"
//                             ? "Connecting..."
//                             : "Google"}
//                         </p>
//                         <p className="text-[10px] text-gray-500 leading-tight">
//                           Connect Gmail account
//                         </p>
//                       </div>
//                     </button>
//                     <button
//                       onClick={() => {
//                         handleConnectAccount("outlook");
//                         setShowConnectOptions(false);
//                       }}
//                       disabled={connectingProvider === "outlook"}
//                       className="flex items-center w-full px-2 py-1 text-xs text-gray-700 hover:bg-blue-50 transition-colors"
//                     >
//                       <div className="flex-shrink-0 mr-2 bg-white p-0.5 rounded-full shadow-sm">
//                         <img
//                           src="https://www.microsoft.com/favicon.ico"
//                           alt="Outlook"
//                           className="w-5 h-5"
//                         />
//                       </div>
//                       <div className="text-left">
//                         <p className="font-medium text-xs leading-tight">
//                           {connectingProvider === "outlook"
//                             ? "Connecting..."
//                             : "Outlook"}
//                         </p>
//                         <p className="text-[10px] text-gray-500 leading-tight">
//                           Connect Microsoft account
//                         </p>
//                       </div>
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default Accounts;

import React, { useState, useEffect, useRef } from "react";
import Joyride, { STATUS } from "react-joyride";
import axios from "axios";
import { AUTH_ENDPOINTS } from "../../config";
import { useSearchParams, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

// Add cache duration constant
const ACCOUNTS_CACHE_DURATION = 30 * 60 * 1000; // 30 minutes in milliseconds
const AUTH_STATUS_CHANGED = "auth_status_changed";

const Accounts = ({ configModalClosed }) => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showConnectOptions, setShowConnectOptions] = useState(false);
  const [connectingProvider, setConnectingProvider] = useState(null);
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const dropdownRef = useRef(null);
  const hasInitialized = useRef(false);
  const navigate = useNavigate();
  const [runTour, setRunTour] = useState(false);
  const [tourSteps, setTourSteps] = useState([]);
  const addButtonRef = useRef(null);

  // Add axios interceptor for global error handling
  useEffect(() => {
    // Add response interceptor to handle authentication errors
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        // When we get a sign-in redirect error but we're already authenticated
        if (error.response && error.response.status === 401) {
          console.error("Authentication error:", error);
          // Check if we have a token
          const token = Cookies.get("access_token");
          if (token) {
            // Refresh the accounts list instead of redirecting
            fetchAccounts(true);
            return Promise.resolve({ data: { status: "recovered" } });
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      // Clean up interceptor when component unmounts
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  // Tour setup effect
  useEffect(() => {
    if (!loading) {
      if (accounts.length === 0) {
        console.log("Setting tour steps for accounts:", accounts);
        setTourSteps([
          {
            target: ".add-account-button",
            content: (
              <div className="text-center">
                <h3 className="font-bold text-blue-600 mb-2">
                  Let's get started!
                </h3>
                <p>Click this button to connect your first email account.</p>
                <p className="text-sm text-gray-600 mt-2">
                  You'll need to connect at least one account to use all the
                  features of our app.
                </p>
              </div>
            ),
            disableBeacon: true,
            placement: "right",
            offset: 20,
            spotlightClicks: true,
          },
        ]);

        if (configModalClosed) {
          console.log("Config modal closed, starting tour");
          setTimeout(() => {
            setRunTour(true);
            console.log("Tour started");
          }, 500);
        } else {
          const hasSeenTour = localStorage.getItem("has_seen_accounts_tour");
          console.log("Has seen tour:", hasSeenTour);
          if (!hasSeenTour) {
            setTimeout(() => {
              setRunTour(true);
              console.log("Tour started (new user)");
            }, 500);
          }
        }
      }
    }
  }, [configModalClosed, loading, accounts]);

  // Listen for auth status changes (like logout)
  useEffect(() => {
    const handleAuthChange = () => {
      console.log("Auth status changed, updating accounts");
      // Check if we're logged in
      const token = Cookies.get("access_token");
      if (!token) {
        // If logged out, clear accounts cache
        clearAccountsCache();
        setAccounts([]);
      } else {
        // If logged in, refresh accounts
        fetchAccounts(true);
      }
    };

    window.addEventListener(AUTH_STATUS_CHANGED, handleAuthChange);
    return () => {
      window.removeEventListener(AUTH_STATUS_CHANGED, handleAuthChange);
    };
  }, []);

  // Main initialization effect
  useEffect(() => {
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    // Check URL parameters for connection status
    const accountConnected = searchParams.get("account_connected");
    const connectionError = searchParams.get("error");

    if (accountConnected === "true") {
      setSuccessMessage("Email account successfully connected!");
      setTimeout(() => setSuccessMessage(null), 3000);
      // Force refresh when account was just connected
      fetchAccounts(true);
      // Clean up URL
      const params = new URLSearchParams(searchParams);
      params.delete("account_connected");
      navigate({ search: params.toString() }, { replace: true });
    } else if (connectionError) {
      setError(`Connection issue: ${decodeURIComponent(connectionError)}`);
      setTimeout(() => setError(null), 5000);
      // Clean up URL
      const params = new URLSearchParams(searchParams);
      params.delete("error");
      navigate({ search: params.toString() }, { replace: true });
      // Still load cached accounts if available
      loadAccountsFromCache();
    } else {
      // Normal initialization - try cache first
      loadAccountsFromCache();
    }

    // Add click outside listener for dropdown
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowConnectOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchParams, navigate]);

  const clearAccountsCache = () => {
    localStorage.removeItem("cached_accounts");
    localStorage.removeItem("accounts_cache_timestamp");
  };

  const isCacheValid = () => {
    const cacheTimestamp = localStorage.getItem("accounts_cache_timestamp");
    if (!cacheTimestamp) return false;

    const now = Date.now();
    const lastCacheTime = parseInt(cacheTimestamp);
    const cacheAge = now - lastCacheTime;

    return cacheAge < ACCOUNTS_CACHE_DURATION;
  };

  const loadAccountsFromCache = () => {
    const cachedAccounts = localStorage.getItem("cached_accounts");

    if (cachedAccounts) {
      try {
        const parsedAccounts = JSON.parse(cachedAccounts);
        console.log("Using cached accounts data (API call avoided)");
        setAccounts(parsedAccounts);
        setLoading(false);
        return true;
      } catch (error) {
        console.error("Error parsing cached accounts:", error);
        clearAccountsCache();
      }
    }

    // Only fetch if no cached accounts exist at all
    console.log("No cached accounts found, fetching from API");
    fetchAccounts(true);
    return false;
  };

  const saveAccountsToCache = (accountsData) => {
    try {
      localStorage.setItem("cached_accounts", JSON.stringify(accountsData));
      localStorage.setItem("accounts_cache_timestamp", Date.now().toString());
      console.log("Accounts data cached successfully");
    } catch (error) {
      console.error("Error caching accounts data:", error);
    }
  };

  const fetchAccounts = async (forceFresh = false) => {
    const accounts = localStorage.getItem("cached_accounts");
    if (!forceFresh || accounts || isCacheValid()) {
      console.log("Using cached accounts data silently");
      return;
    }
    // If not forcing fresh data and we have cached accounts, always use them
    if (!forceFresh) {
      const cachedAccounts = localStorage.getItem("cached_accounts");
      if (cachedAccounts) {
        try {
          const parsedAccounts = JSON.parse(cachedAccounts);
          console.log("Using cached accounts data (fetch completely avoided)");
          setAccounts(parsedAccounts);
          setLoading(false);
          return;
        } catch (error) {
          console.error("Error parsing cached accounts:", error);
        }
      }
    }

    try {
      console.log("Fetching fresh accounts data from API");
      setLoading(true);
      const response = await axios.get(AUTH_ENDPOINTS.USER_ACCOUNTS);
      console.log("Accounts data:", response.data);

      // Check if response is HTML instead of JSON (invalid API URL issue)
      if (
        typeof response.data === "string" &&
        response.data.includes("<!doctype html>")
      ) {
        console.error(
          "Received HTML instead of JSON. API URL configuration issue."
        );
        setError("API configuration error. Please check console logs.");
        setAccounts([]);
        setLoading(false);
        return;
      }

      // Validate that data is an array
      if (!Array.isArray(response.data)) {
        console.error("Expected array but got:", typeof response.data);
        setError("Unexpected data format received.");
        setAccounts([]);
        setLoading(false);
        return;
      }

      // Add more detailed logging for avatar URLs and connection status
      if (response.data && response.data.length > 0) {
        response.data.forEach((account) => {
          console.log(
            `Account ${account.email} avatar: ${account.user_avatar || "none"}`
          );
          console.log(
            `Account ${account.email} authenticated: ${account.is_authenticated}`
          );
        });
      }

      setAccounts(response.data);
      setLoading(false);

      // Cache the fresh accounts data
      saveAccountsToCache(response.data);
    } catch (err) {
      console.error("Error fetching accounts:", err);
      setLoading(false);
      setError("Failed to load accounts. Please try again.");
      setTimeout(() => setError(null), 3000);

      // Try to use cached data as fallback on error
      const cachedAccounts = localStorage.getItem("cached_accounts");
      if (cachedAccounts) {
        try {
          const parsedAccounts = JSON.parse(cachedAccounts);
          console.log("Using cached accounts as fallback");
          setAccounts(parsedAccounts);
        } catch (e) {
          console.error("Error using cached accounts as fallback:", e);
        }
      }
    }
  };

  const handleConnectAccount = async (provider) => {
    try {
      setConnectingProvider(provider);
      let response;

      if (provider === "google") {
        response = await axios.post(AUTH_ENDPOINTS.GOOGLE_CONNECT);
      } else if (provider === "outlook") {
        response = await axios.post(AUTH_ENDPOINTS.OUTLOOK_CONNECT);
      }

      if (response && response.data && response.data.auth_url) {
        // Store current route to return to after auth
        sessionStorage.setItem("connecting_provider", provider);
        sessionStorage.setItem("return_to_path", window.location.pathname);

        // Clear cache before redirecting to ensure fresh data on return
        clearAccountsCache();

        // Redirect to auth URL
        window.location.href = response.data.auth_url;
      }
    } catch (err) {
      console.error(`Error connecting ${provider} account:`, err);
      let errorMessage = `Failed to connect ${provider} account.`;

      // Provide more specific error message if available
      if (err.response && err.response.data && err.response.data.detail) {
        errorMessage += ` ${err.response.data.detail}`;
      }

      setError(errorMessage);
      setConnectingProvider(null);
      setTimeout(() => setError(null), 3000);
    }
  };

  const handleRemoveAccount = async (account) => {
    if (!window.confirm("Are you sure you want to remove this account?")) {
      return;
    }

    try {
      await axios.post(AUTH_ENDPOINTS.REMOVE_ACCOUNT, {
        email: account.email,
      });
      setSuccessMessage("Account removed successfully");
      setTimeout(() => setSuccessMessage(null), 3000);

      // Clear cache and force refresh after removing account
      clearAccountsCache();
      fetchAccounts(true);
    } catch (err) {
      console.error("Error removing account:", err);
      let errorMessage = "Failed to remove account.";

      if (err.response && err.response.status === 400) {
        errorMessage =
          err.response.data.detail ||
          "Cannot remove the only account. At least one account is required.";
      }

      setError(errorMessage);
      setTimeout(() => setError(null), 3000);
    }
  };

  const handleJoyrideCallback = (data) => {
    const { status } = data;

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setRunTour(false);
      localStorage.setItem("has_seen_accounts_tour", "true");
    }
  };

  return (
    <>
      <Joyride
        steps={tourSteps}
        run={runTour}
        continuous={true}
        showSkipButton={true}
        callback={handleJoyrideCallback}
        debug={true}
        disableScrolling={false}
        locale={{
          last: "Got it",
          skip: "Skip",
          next: "Next",
          back: "Back",
        }}
        styles={{
          options: {
            primaryColor: "#1F9BFF",
            zIndex: 9999,
          },
          tooltip: {
            fontSize: "14px",
            padding: "15px",
            borderRadius: "10px",
            backgroundColor: "white",
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
          },
          tooltipContainer: {
            textAlign: "center",
          },
          tooltipTitle: {
            fontSize: "18px",
            fontWeight: "600",
            margin: "0 0 10px 0",
            color: "#1F9BFF",
          },
          tooltipContent: {
            padding: "5px 0",
            fontSize: "14px",
            color: "#4A5568",
          },
          buttonNext: {
            backgroundColor: "#1F9BFF",
            padding: "8px 15px",
            fontSize: "14px",
            fontWeight: "500",
            borderRadius: "6px",
            border: "none",
            boxShadow: "0 4px 6px rgba(31, 155, 255, 0.2)",
            transition: "all 0.2s ease",
          },
          buttonBack: {
            color: "#1F9BFF",
            marginRight: "10px",
          },
          buttonSkip: {
            color: "#718096",
            fontSize: "13px",
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
          spotlight: {
            borderRadius: "8px",
            boxShadow: "0 0 0 4px rgba(31, 155, 255, 0.3)",
          },
          floater: {
            arrow: {
              color: "white",
              length: 12,
              spread: 8,
            },
          },
        }}
      />
      <div className="bg-[#1F9BFF1A] font-bold text-md w-[96%] m-auto p-3 rounded-md rounded-b-none flex items-center justify-between text-black mt-2 px-4">
        <h1>Accounts</h1>
        {error && (
          <div className="text-red-600 text-sm font-normal mr-2">{error}</div>
        )}
        {successMessage && (
          <div className="text-green-600 text-sm font-normal mr-2">
            {successMessage}
          </div>
        )}
      </div>
      <div className="bg-white w-[96%] min-h-[35%] m-auto rounded-lg rounded-t-none flex pt-3 pb-2 mb-3 relative">
        {loading ? (
          <div className="flex justify-center items-center h-14 w-full">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-400"></div>
          </div>
        ) : (
          <div className="p-2 flex flex-wrap gap-4 w-full">
            {accounts.map((account, index) => {
              // Define an array of background colors for different accounts
              const bgColors = [
                "bg-blue-50 hover:bg-blue-100",
                "bg-purple-50 hover:bg-purple-100",
                "bg-green-50 hover:bg-green-100",
                "bg-amber-50 hover:bg-amber-100",
                "bg-rose-50 hover:bg-rose-100",
                "bg-cyan-50 hover:bg-cyan-100",
              ];

              // Get background color based on index (cycles through the array)
              const bgColorClass = bgColors[index % bgColors.length];

              // Get border color matching the background
              const borderColorClass = bgColorClass
                .replace("bg-", "border-")
                .replace(" hover:bg-blue-100", "")
                .replace(" hover:bg-purple-100", "")
                .replace(" hover:bg-green-100", "")
                .replace(" hover:bg-amber-100", "")
                .replace(" hover:bg-rose-100", "")
                .replace(" hover:bg-cyan-100", "");

              return (
                <div
                  key={account.id}
                  className={`w-50 ${borderColorClass} p-2 rounded-lg text-left flex flex-col ${bgColorClass} relative group transition-colors duration-200`}
                >
                  <div className="flex items-center gap-1">
                    <img
                      src={account?.email_avatar || "/default-avatar.svg"}
                      alt={`${account.email} avatar`}
                      referrerPolicy="no-referrer"
                      crossOrigin="anonymous"
                      className="w-6 h-6 rounded-full"
                      onError={(e) => {
                        console.error(
                          "Failed to load account avatar, using fallback",
                          account?.user_avatar
                        );
                        e.target.onerror = null;
                        e.target.src = "/default-avatar.svg";
                      }}
                    />
                    <div className="ml-1 overflow-hidden">
                      <p className="font-medium leading-none text-sm mb-1 truncate">
                        {account?.full_name}
                      </p>
                      <p className="text-gray-500 leading-none text-xs truncate">
                        {account?.email}
                      </p>
                    </div>
                  </div>

                  {/* Remove account button - shows on hover */}
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveAccount(account);
                    }}
                    className="absolute top-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity p-1 hover:bg-red-100 rounded-full"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 text-red-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              );
            })}

            {/* Add account button with dropdown */}
            <div className="relative" ref={dropdownRef}>
              <button
                ref={addButtonRef}
                onClick={() => setShowConnectOptions(!showConnectOptions)}
                className="flex items-center justify-center w-10 h-10 add-account-button"
              >
                <div className="bg-[#1F9BFF1A] rounded-full p-2 hover:bg-[#1F9BFF33] transition-colors">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 text-[#1F9BFF]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 4v16m8-8H4"
                    />
                  </svg>
                </div>
              </button>

              {/* Connection options dropdown */}
              {showConnectOptions && (
                <div className="absolute top-0 -right-48 w-44 bg-white rounded-lg shadow-lg z-50 border border-blue-100 overflow-hidden transition-all duration-200 ease-in-out transform">
                  <div className="py-1 px-2 bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-blue-100">
                    <h3 className="text-xs font-semibold text-blue-700">
                      Connect account
                    </h3>
                  </div>
                  <div className="py-0.5">
                    <button
                      onClick={() => {
                        handleConnectAccount("google");
                        setShowConnectOptions(false);
                      }}
                      disabled={connectingProvider === "google"}
                      className="flex items-center w-full px-2 py-1 text-xs text-gray-700 hover:bg-blue-50 transition-colors"
                    >
                      <div className="flex-shrink-0 mr-2 bg-white p-0.5 rounded-full shadow-sm">
                        <img
                          src="https://www.google.com/favicon.ico"
                          alt="Google"
                          className="w-5 h-5"
                        />
                      </div>
                      <div className="text-left">
                        <p className="font-medium text-xs leading-tight">
                          {connectingProvider === "google"
                            ? "Connecting..."
                            : "Google"}
                        </p>
                        <p className="text-[10px] text-gray-500 leading-tight">
                          Connect Gmail account
                        </p>
                      </div>
                    </button>
                    <button
                      onClick={() => {
                        handleConnectAccount("outlook");
                        setShowConnectOptions(false);
                      }}
                      disabled={connectingProvider === "outlook"}
                      className="flex items-center w-full px-2 py-1 text-xs text-gray-700 hover:bg-blue-50 transition-colors"
                    >
                      <div className="flex-shrink-0 mr-2 bg-white p-0.5 rounded-full shadow-sm">
                        <img
                          src="https://www.microsoft.com/favicon.ico"
                          alt="Outlook"
                          className="w-5 h-5"
                        />
                      </div>
                      <div className="text-left">
                        <p className="font-medium text-xs leading-tight">
                          {connectingProvider === "outlook"
                            ? "Connecting..."
                            : "Outlook"}
                        </p>
                        <p className="text-[10px] text-gray-500 leading-tight">
                          Connect Microsoft account
                        </p>
                      </div>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Accounts;
